import { AuthModal } from "@/components/AuthModal";
import {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";
// import { RequireAuth } from "components/RequireAuth";

interface AuthModalContextType {
  showLoginModal: () => void;
  hideLoginModal: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | null>(null);

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false);

  const showLoginModal = useCallback(() => setVisible(true), []);
  const hideLoginModal = useCallback(() => setVisible(false), []);

  return (
    <AuthModalContext.Provider value={{ showLoginModal, hideLoginModal }}>
      {children}
      {visible && (
        <AuthModal isFullPage={false} closable closeModal={hideLoginModal} />
      )}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  if (!context)
    throw new Error("useAuthModal must be used within AuthModalProvider");
  return context;
};
